import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PROPERTY_ACTION_TYPE } from '../actions';

const initialState = {};

const propertiesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case PROPERTY_ACTION_TYPE.GET_PROPERTIES: {
        return payload || initialState;
      }

      case PROPERTY_ACTION_TYPE.REMOVE_PROPERTY:
        delete draft[meta.propertyId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default propertiesReducer;
